import { Component, Input } from '@angular/core';
import { CommonModule } from "@angular/common";
import { ChartModule } from "primeng/chart";
import { SharedModule } from '@shared/shared.module';
import { SalesService } from '@shared/services/sales.service';
import { ItemFileService } from '@shared/services/item-file.service';
import { Utils } from '@shared/utils';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
    standalone: true,
    selector: 'app-top-profitables-widget',
    inputs: ['dateStart', 'dateEnd'],
    imports: [CommonModule,ChartModule,SharedModule,CheckboxModule,FormsModule],
    templateUrl:"./topprofitableswidget.html"
})
export class TopProfitablesWidget {
    @Input() dateStart!: Date;
    @Input() dateEnd!: Date;
    
    topItems: any[]=[];
    isTopItemsLoading: boolean = true;
    useNetProfit: boolean = false;

    todayStart!: Date;
    todayEnd!: Date;

    constructor(private salesService: SalesService,
        private itemFileService: ItemFileService) {
        
    }
    ngOnInit() {
        this.todayStart = this.dateStart || new Date(new Date().toDateString());
        this.todayEnd = this.dateEnd || new Date(this.todayStart.getTime() + (1000 * 60 * 60 * 24));
        
        this.getTopProfitables();
    }

    getTopProfitables() {
        this.isTopItemsLoading = true;
        this.salesService.getTopProfitables(this.todayStart, this.todayEnd, 10, this.useNetProfit)
            .subscribe((topItems) => {
                this.topItems = topItems;
                this.isTopItemsLoading = false;
            });
    }
    getImageUrlForItemId(grnItem: any, attributeName: string) {
        return this.itemFileService.getItemImageUrlForItemId(grnItem.itemId as string, attributeName, grnItem.mainImage);
    }
    getStorefrontImage(strorefront: string) {
       return Utils.getStorefrontImage(strorefront);
    }
}